import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import App from './App';
import './index.css'

import translationEN from "./locales/en.json";
import translationFR from "./locales/fr.json";

import AuthContextProvider from './context/AuthContext';
import ModeContextProvider from './context/ModeContext';

let mode = localStorage.getItem('gsmart-mode');
if (!mode) {
  mode = 'bright';
  localStorage.setItem('gsmart-mode', mode);
}

let lang = localStorage.getItem('gsmart-lang');
if (!lang) {
  lang = 'fr'
  localStorage.setItem('gsmart-lang', lang);
}

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  }
};
i18n.use(initReactI18next).init({
  resources,
  lng: lang,
  fallbackLng: lang,
  interpolation: {
    escapeValue: false,
  }
});

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ModeContextProvider>
        <AuthContextProvider>
          {/* <TaskContextProvider> */}
            <App />
          {/* </TaskContextProvider> */}
        </AuthContextProvider>
      </ModeContextProvider>
    </QueryClientProvider>
  // </React.StrictMode>
);